import { createTheme } from "@mui/material/styles";

import breakpoints from "./breakpoints";
import buildComponents from "./components";
import buildPalette from "./palette";
import shadows from "./shadows";
import { ColorMode } from "./tokens";
import typography from "./typography";

export type { ColorMode } from "./tokens";

/**
 * The CSI Pay MUI theme for one colour mode. Spacing (4px) and breakpoints
 * (md 960, lg 1280) are unchanged from the original template on purpose:
 * every screen's layout depends on them.
 */
export default function createAppTheme(mode: ColorMode) {
  return createTheme({
    spacing: 4,
    breakpoints,
    shape: { borderRadius: 4 },
    typography,
    shadows,
    palette: buildPalette(mode),
    components: buildComponents(mode),
  });
}
